<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/150kW-M/150kW-M.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">150kW Integrated Electric Drive Assembly</div>
                <div class="detail-banner-desc transmission">Multi-in-1 electric drive assembly integrating Motor + MCU + VCU +
                    Gearbox + OBC + DCDC + PDU

                    <div class="detail-desc">
                        <div>
                            MCU & VCU, electric motor, reducer, OBC, DCDC, PDU, and supports EVCC compatibility;<br />
                        </div>
                        <div>
                            The assembly features an innovative integrated shaft design, achieving an ultra-compact size
                            of 451*437*339mm. Multiple full-domain efficiency enhancement technologies enable a CLTC
                            cycle efficiency of ≥90%;<br />
                        </div>
                        <div>
                            Software 5-in-1 integration incorporates vehicle control, adaptive thermal management,
                            intelligent power management, AI-based cloud diagnostics, active heating, and redundant
                            virtual sensing (including stator/rotor temperature estimation and resolver position
                            estimation);<br />
                        </div>
                        <div>
                            The power system utilizes all-SiC high-efficiency power devices, supporting 6 kVA V2V and
                            V2L discharge, intelligent charging technology, and high-voltage safety monitoring during
                            external discharge processes.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/150kW-M/150kW-M-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">150kW</div>
                                    <div class="k">Motor peak power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">20000rpm</div>
                                    <div class="k">Motor max speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3450N·m</div>
                                    <div class="k">Max output torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Oil</div>
                                    <div class="k">Motor cooling</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1</div>
                                    <div class="k">Gear</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">451*437*339</div>
                                    <div class="k">Axial size X*Y*Z(mm)</div>
                                </div>

                                <div class="spec-item">
                                    <div class="v">6.6kW</div>
                                    <div class="k">OBC Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3kW</div>
                                    <div class="k">DCDC Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">79kg</div>
                                    <div class="k">Axial weight</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '150kW Integrated Electric Drive Assembly - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission/150-m.html'

};

import { createApp } from 'vue';
import App from './150-m.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./150-m.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
